import React from 'react';
import { TEMPLATES } from '../templates';

const CHANNEL_ICONS = {
  meta:       '📘',
  google:     '🔍',
  youtube:    '▶️',
  tiktok:     '🎵',
  spotify:    '🟢',
  linkedin:   '💼',
  ig_organic: '📸',
};

function getChannels(template) {
  const channels = new Set();
  (template.sections || []).forEach((s) => s.blocks.forEach((b) => channels.add(b.channel)));
  return Array.from(channels);
}

export default function TemplateSelector({ clientId, onSelect }) {
  const templates = clientId
    ? TEMPLATES.filter((t) => !t.client_ids || t.client_ids.includes(clientId))
    : TEMPLATES;

  return (
    <div style={{ padding: '24px' }}>
      <h2 style={{ marginBottom: '20px', fontSize: '18px', fontWeight: 700, color: 'var(--text)', margin: '0 0 20px' }}>
        Seleziona tipo di report
      </h2>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))', gap: '12px' }}>
        {templates.map((template) => {
          const channels = getChannels(template);
          return (
            <button
              key={template.id}
              onClick={() => onSelect(template)}
              style={{
                background: 'var(--bg2)',
                border: '1px solid var(--border)',
                borderRadius: '10px',
                padding: '18px',
                textAlign: 'left',
                cursor: 'pointer',
                transition: 'border-color 0.15s',
                fontFamily: 'inherit',
              }}
              onMouseEnter={(e) => { e.currentTarget.style.borderColor = '#6366f1'; }}
              onMouseLeave={(e) => { e.currentTarget.style.borderColor = 'var(--border)'; }}
            >
              <div style={{ fontSize: '15px', fontWeight: 700, color: 'var(--text)', marginBottom: '4px' }}>
                {template.label}
              </div>
              {template.description && (
                <div style={{ fontSize: '12px', color: 'var(--text2)', marginBottom: '12px', lineHeight: '1.4' }}>
                  {template.description}
                </div>
              )}
              <div style={{ display: 'flex', gap: '5px', flexWrap: 'wrap' }}>
                {channels.map((ch) => (
                  <span
                    key={ch}
                    style={{
                      fontSize: '11px',
                      background: 'var(--bg)',
                      border: '1px solid var(--border)',
                      borderRadius: '5px',
                      padding: '2px 7px',
                      color: 'var(--text2)',
                    }}
                  >
                    {CHANNEL_ICONS[ch] ?? '📊'} {ch}
                  </span>
                ))}
              </div>
              {template.hide_economics && (
                <div style={{ marginTop: '8px', fontSize: '11px', color: '#f59e0b' }}>
                  ✦ No economics
                </div>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
